<style>
  @import "./pageTransAnimate.less";

  .sub-view {
    position: absolute;
    min-height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    padding-top: 2.2rem;
  }

  .viewch-transition {
    transition: all 0.3s ease;
  }

  .viewch-enter,
  .viewch-leave {
    opacity: 0;
    transform: translate3d(0, 0, 10px);
  }

  .viewch2-transition,
  .viewch3-transition,
  .viewch4-transition {
    transition: all 0.4s ease;
  }

  .viewch2-enter,
  .viewch2-leave {
    opacity: 0;
    transform: translate3d(0, 30rem, 1rem);
  }

  .viewch3-enter,
  .viewch3-leave {
    opacity: 0;
    transform: translate3d(30rem, 0, 1rem);
  }

  .viewch4-enter,
  .viewch4-leave {
    opacity: 0;
    transform: scaleY(0.01);
  }

  [v-cloak] {
    display: none;
  }

  input::-webkit-input-placeholder {
    color: darkgray;
  }

  .fade-enter-active,
  .fade-leave-active {
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0.01;
  }

  .viewch4-enter-active,
  .viewch4-leave-active {
    -webkit-transition-duration: 0.4s;
    transition-duration: 0.4s;
    opacity: 1;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
  }

  .viewch4-enter,
  .viewch4-leave-active {
    opacity: 0.01;
    -webkit-transform: scaleY(0.01);
    transform: scaleY(0.01);
  }

  .slider-enter,
  .slidel-enter {
    opacity: 0.01;
  }

  .slider-enter-active,
  .slider-leave-active,
  .slidel-enter-active,
  .slidel-leave-active {
    min-height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .slider-enter-active {
    -webkit-animation: slider-in 0.5s;
    animation: slider-in 0.5s;
  }

  .slider-leave-active {
    -webkit-animation: slider-out 0.5s;
    animation: slider-out 0.5s;
  }

  .slidel-enter-active {
    -webkit-animation: slidel-in 0.5s;
    animation: slidel-in 0.5s;
  }

  .slidel-leave-active {
    -webkit-animation: slidel-out 0.5s;
    animation: slidel-out 0.5s;
  }

  .ajax-ing {
    position: fixed;
    z-index: 101;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0);
  }

  .ajax-ing .loaderBox {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0.6rem 0.7rem 0.4rem;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.7);
    text-align: center;
    color: #fff;
    font-size: 0.5rem;
    border-radius: 5px;
  }

  .ajax-ing-tip .loaderBox {
    padding: 0.9rem 1.2rem 1rem;
  }

  .ajax-ing-tip .f-tac {
    font-size: 0.65rem;
    line-height: 0.85rem;
    max-width: 14.5rem;
  }

  .loaderBox .circular {
    width: 2rem;
    height: 2rem;
    animation: loading-rotate 2s linear infinite;
  }

  .loaderBox .circular .path {
    animation: loading-dash 1.5s ease-in-out infinite;
    stroke-dasharray: 90, 150;
    stroke-dashoffset: 0;
    stroke-width: 3px;
    stroke: #fff;
    stroke-linecap: round;
  }

  @keyframes loading-rotate {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loading-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -40px;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -100px;
    }
  }

</style>

<template>
  <div>
    <transition :name="pageTranSet.transitionType" :mode="pageTranSet.transitionMode" appear>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>

    <div v-show="ajaxState.flag>0" class="ajax-ing" :class="{ 'ajax-ing-tip': ajaxState.tip }">
      <div class="loaderBox">
        <svg viewBox="0,0,40,40" class="circular">
          <circle cx="20" cy="20" r="15" fill="none" class="path"></circle>
        </svg>
        <div v-if="ajaxState.tip" class="f-tac">{{ajaxState.tip}}</div>
      </div>
    </div>
    <toast ref="toast"></toast>
    <alert ref="alert"></alert>
    <confirm ref="confirm"></confirm>
  </div>
</template>
<script>
  import alert from '../alert';
  import toast from '../toast';
  import confirm from '../confirm';

  import getAppInfo from 'bjxy-common/helper/getAppInfo';
  import addUrlQuery from 'bjxy-common/helper/addUrlQuery'
  import finishH5Page from 'bjxy-common/jsBridge/finishH5Page'
  import {mapState} from 'vuex';

  export default {
    data() {
      return {
      };
    },
    computed: {
      ...mapState([
        'pageTitle',
        'loginState',
        'ajaxState',
        'pageTranSet',
        'appInfo',
        'useLogin'
      ])
    },
    watch: {
      pageTitle(title) {
        document.title = title;
      },
      loginState(state) {
        if (state === false && this.appInfo.app && this.useLogin) {
          window.finishH5Page = function () {
            finishH5Page()
          }
          var backUrl = addUrlQuery(location.href,`t=${new Date().getTime()}`)
          window.location.href = 'cardloan://login?callBack=finishH5Page&fromUrl=' + encodeURIComponent(backUrl);
        }
      },
    },
    created() {
      window.xy_App = this;
      this.$store.commit('appInfo', getAppInfo());
      //壳包根据渠道号区分要显示的名称
    },
    components: {
      alert,
      confirm,
      toast,
    },
  };

</script>
